import { IsTest, getLang } from "@/utils/tools";
import { game_id, isHtm } from "@/utils/const";
import { request } from "..";

// TODO 请求域名确定
const testOrigin = "https://test-sg-act.playerinfinite.com/";
const prodOrigin = "https://sg-act.playerinfinite.com/";
const origin = IsTest ? testOrigin : prodOrigin;
interface commomRes {
  code: number;
  msg: string;
  data?: any;
}

export interface RoleInfo{
  area_id: string;
  game_id: number;
  game_name: string;
  plat_id: string;
  role_name: string;
  zone_id: string;
  role_id: string;
}

const lang_type = getLang();

interface GetRoleInfoReq{
  area_id: string;
  zone_id: string;
}
interface GetRoleInfoRes extends commomRes {
  data: {
    role_list: RoleInfo[];
  };
}

// @see https://yapi.intlgame.com/project/1344/interface/api/83796
export const getRoleInfo = async (params: GetRoleInfoReq) => {
  const flow = {
    en: "Wand-20240513104652-F295d4644ffc4",
    ru: "Wand-20240527124716-Fa785f0363650"
  }[getLang()]
  const otherurl = `api/flow/${flow}`;
  return request
    .post<GetRoleInfoRes>(`${origin}${otherurl}`, {
      checkLogin: true,
      needLogin: true,
      lang_type,
      ...params,
    })
    .then((res) => res.data);
};

type SaveRoleInfoRes = commomRes;
// @see https://yapi.intlgame.com/project/1344/interface/api/83816
export const saveRoleInfo = async (params: Partial<RoleInfo>) => {
  const flow = {
    en: "Wand-20240513090037-F80ea6ade111c",
    ru: "Wand-20240527124716-Fd40b912f6727"
  }[getLang()]
  const otherurl = `api/flow/${flow}`;
  return request
    .post<SaveRoleInfoRes>(`${origin}${otherurl}`, params)
    .then((res) => res.data);
};
/**
 * 1-2 下载游戏 关注官方社媒 
 * 3-8 副本
 * 9-11 分享 预约 加入Discord
 */
export const enum TagEnum {
  Share = '9',
  Subscribe = '10',
  OfficalMedia = '2',
  Discord = '11',
  Download = '1',
  DungeonFish = '3',
  DungeonWar = '4',
  DungeonDoctor = '5',
  DungeonForest = '6',
  DungeonDruid = '7',
  DungeonDragon = '8',
}

export interface MissionDone {
  day_limit: number,
  mission_has_done: boolean,
  tag_id: TagEnum,
  total_limit: number
}
interface GetLoginedInitInfoRes extends commomRes {
  data: {
    has_sign_up: boolean; // 是否预约
    lottery_num: number; //剩余次数
    mission_done_list: MissionDone[]; // 任务状态
    compare_reuslt: boolean; // 是否开服
    get_saved_role_info: RoleInfo; // 角色信息
  };
}
// TODO htm 待确定
export const getLoginedInitInfo = async () => {
  const flow = {
    en: "Wand-20240513020357-F2de061ef3f63",
    ru: "Wand-20240527124716-F98faffaa905c"
  }[getLang()]
  const otherurl = `api/flow/${flow}`;
  return request
    .post<GetLoginedInitInfoRes>(`${origin}${otherurl}`,  {
      checkLogin: true,
      needLogin: false,
      lang_type,
    })
    .then((res) => res.data);
};


export const submitShare = async () => {
  const flow = {
    en: "Wand-20240516093537-Faf1c91acc66b",
    ru: "Wand-20240527124716-F1ee5c98570f7"
  }[getLang()]
  const otherurl = `api/flow/${flow}`;
  return request
    .post<commomRes>(`${origin}${otherurl}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
    })
    .then((res) => res.data);
};

export const submitSubscribe = async () => {
  const flow = {
    en: "Wand-20240516093711-F23940d245756",
    ru: "Wand-20240527124716-F22e390e72140"
  }[getLang()]
  const otherurl = `api/flow/${flow}`;
  return request
    .post<commomRes>(`${origin}${otherurl}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
    })
    .then((res) => res.data);
};

export const submitOfficalMedia = async () => {
  const flow = {
    en: "Wand-20240513015607-F9b854d2bf336",
    ru: "Wand-20240527124716-F90e038d7b908"
  }[getLang()]
  const otherurl = `api/flow/${flow}`;
  return request
    .post<commomRes>(`${origin}${otherurl}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
    })
    .then((res) => res.data);
};

export const submitDiscord = async () => {
  const flow = {
    en: "Wand-20240516093744-Fa32b8abf3bb8",
    ru: "Wand-20240527124716-F13311615381a"
  }[getLang()]
  const otherurl = `api/flow/${flow}`;
  return request
    .post<commomRes>(`${origin}${otherurl}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
    })
    .then((res) => res.data);
};

export const submitDownload = async () => {
  const flow = {
    en: "Wand-20240513015457-Fd9d1f4c86e69",
    ru: "Wand-20240527124716-Ffc23f5566232"
  }[getLang()]
  const otherurl = `api/flow/${flow}`;
  return request
    .post<commomRes>(`${origin}${otherurl}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
    })
    .then((res) => res.data);
};

export const submitAddress = async (params: RecordArress) => {
  const flow = {
    en: "Wand-20240513014139-F72875c6e80e6",
    ru: "Wand-20240527124716-Fad2381d9ac60"
  }[getLang()]
  const otherurl = `api/flow/${flow}`;
  return request
    .post<commomRes>(`${origin}${otherurl}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
      ...params
    })
    .then((res) => res.data);
};

interface RecordArress {
  name: string;
  address: string;
  email: string;
  zip_code?: string;
  phone_number?: string;
  country?: string;
}
interface GetAddressRes extends commomRes{
  data: {
    address_info: RecordArress;
  }
}

export const getAddress = async () => {
  const flow = {
    en: "Wand-20240513014126-F315f6f41c82d",
    ru: "Wand-20240527124716-F2cd922bcd00a"
  }[getLang()]
  const otherurl = `api/flow/${flow}`;
  return request
    .post<GetAddressRes>(`${origin}${otherurl}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
    })
    .then((res) => res.data);
};

export const enum GiftType {
  RealGoods = 'real_good', // 实物
  CustomCdkey = 'custom_cdkey', // cdkey
  AmsPropPlaceholder = 'ams_prop_placeholder', // ams 占位
  AmsProp = 'ams_prop', // ams 占位
}

export const enum SendStatus {
  UnRecieved = 0,
  Issued = 1, // 已发放
  Recieved = 3,
}
export interface Present {
  "detail": {
    "cark": string,
    "cdkey": string,
    "password": string,
    "role_info": string,
    "serial_no": string
  },
  "level": string, // id
  "present_cid": string,
  "present_id": string,
  "present_type": GiftType, 
  "send_status": SendStatus,
  "send_timestamp": string,
  "sent_remark": string
  "unsend_present_key": string
}
interface GetRewardRecordRes extends commomRes {
  data: {
    present_has_list: Present[];
  };
}
export const getRewardRecord = async () => {
  const flow = {
    en: "Wand-20240513021712-Fb1d90978d629",
    ru: "Wand-20240527124716-F9233ef77dcc8"
  }[getLang()]
  const otherurl = `api/flow/${flow}`;
  return request
    .post<GetRewardRecordRes>(`${origin}${otherurl}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
    })
    .then((res) => res.data);
};


export interface RankRewardRecord {
  rank: number;
  instance_id: string;
  present_id: string;
}
interface GetRankRewardRecordRes extends commomRes {
  data: {
    has_sign_up: boolean,
    taris_open_present_list: {
      present_list: RankRewardRecord[]
    },
    // present_has_list: Present[];
  };
}
export const getRankRewardRecord = async () => {
  const flow = {
    en: "Wand-20240517091523-Fb413fe5a340e",
    ru: "Wand-20240527124716-Fd7207080af6a"
  }[getLang()]
  const otherurl = `api/flow/${flow}`;
  return request
    .post<GetRankRewardRecordRes>(`${origin}${otherurl}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
    })
    .then((res) => res.data);
};

interface LottoryRes extends commomRes {
  data: {
    present: {
      "present_id": string,
      "present_list": Present[],
      "send_type": number
    }
  };
}

export const submitLottery = async () => {
  // TODO tempFlow 
  // const flow = {
  //   en: "Wand-20240620124431-F358fcc9ea262",
  //   ru: "Wand-20240620124324-F3164afa2afaf"
  // }[getLang()];
  const flow = {
    en: "Wand-20240511072826-Fa97f88b86b85",
    ru: "Wand-20240527124716-F37bdbdc12482"
  }[getLang()]
  const otherurl = `api/flow/${flow}`;
  return request
    .post<LottoryRes>(`${origin}${otherurl}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
    })
    .then((res) => res.data);
};

export interface Rank {
  role_name: string;//昵称
  service: string;//服务器
  union_name: string;//工会名称
  // eveltimestamp: number;//通关时间
  rank: number;//排名
  clear_level_timestamp: number;//通关时间 单位s
}
interface GetDungeonRankingRes extends commomRes {
  data: {
    taris_rank_list: {
      rank_list: Rank[];
      self_msg?: Rank;
      total: number;
    };
  };
}
export const getDungeonRanking = async (id: number, page_num = 1) => {
  const flow = {
    en: "Wand-20240517061209-Fb3f6bae86bad",
    ru: "Wand-20240527124716-Ffbf35dddd099"
  }[getLang()]
  const otherurl = `api/flow/${flow}`;
  return request
    .post<GetDungeonRankingRes>(`${origin}${otherurl}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
      instance_id: id,
      page_size: 10,
      page_num,
    })
    .then((res) => res.data);
};

function getSourceFromUrl(search = window.location.search) {
  const params = new URLSearchParams(search);
  const source = ['media', 'network', 'campaign', 'adgroup', 'ad']
    .map(key => {
      return `${key}=${encodeURIComponent(params.get(key) || '')}`;
    })
    .join('&');
  const clickId = params.get('gclid') || params.get('fbclid') || params.get('twclid') || params.get('msclkid') || params.get('yclid') || params.get('_zucks_suid') || params.get('transaction_id') || '';

  return `${source}&clickid=${clickId}`;
}
const baseRequestUrl = 'https://www.jupiterlauncher.com';

async function wandFetch(url: string, data: any) {
  const rawResponse = await fetch(`${baseRequestUrl}${url}`, {
    method: 'post',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json'
    }
  });
  const response = await rawResponse.json();

  return response;
}

export const getShort = async () => {
  const source = getSourceFromUrl();
  const now = Math.ceil(Date.now() / 1000);
  const seq = '';
  const response = await wandFetch(
    `/api/v1/fleet.platform.game.TinyLinkProxy/Long2Short?channel_id=3&game_id=${game_id}&sdk_version=2.0&seq=${seq}&source=1&ts=${now}`,
    { code: `${source}` }
  );
  return response;
};

export const submitRegister = async (params: Partial<RoleInfo> = {}) => {
  const flow = {
    en: "Wand-20240513085857-F746fca2e042f",
    ru: "Wand-20240527124716-F5c0a7c21f086"
  }[getLang()]
  const otherurl = `api/flow/${flow}`;
  return request
    .post<commomRes>(`${origin}${otherurl}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
      ...params,
    })
    .then((res) => res.data);
}

export const getReward = async () => {
  const otherurl = 'api/flow/Wand-20240112015427-F89b3bb4cc697';
  return request
    .post<commomRes>(`${origin}${otherurl}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
    })
    .then((res) => res.data);
};

export const setRewardStatus = async (params:{unsend_present_key:string}) => {
  const flow = {
    en: "Wand-20240604121532-F999313f0b0e7",
    ru: "Wand-20240620092503-Fb923875f199d"
  }[getLang()]
  const otherurl = `api/flow/${flow}`;
  return request
    .post<GetRewardRecordRes>(`${origin}${otherurl}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
      unsend_present_key: params.unsend_present_key,
    })
    .then((res) => res.data);
};

interface GetCompareReusltRes extends commomRes {
  data: {
    compare_reuslt: boolean;
  };
}
export const getCompareReuslt = async () => {
  const flow = {
    en: "Wand-20240617061824-F25a4e19857ad",
    ru: "Wand-20240617062006-F0fbff79f1180"
  }[getLang()]
  const otherurl = `api/flow_direct/${flow}`;
  return request
    .post<GetCompareReusltRes>(`${origin}${otherurl}`,  {
      checkLogin: false,
      needLogin: false,
      lang_type,
    })
    .then((res) => res.data);
};